
<template>
  <div v-if="options.meta[cellKey]">
    <editor-content class="editor__content" :editor="editor" onUpdate="onChange" />
  </div>
</template>

<script>

import { Editor, EditorContent } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  Mention,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Table,
  TableHeader,
  TableCell,
  TableRow,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions'
export default {
  props: [
    'rowKey',
    'cellKey',
    'cellVal',
    'options',
    'gridId',
    'widgetKey',
    'display',
    'editMode',
    'fbField',
    'controlInfo',
  ],
  components: {
    EditorContent
  },
  data() {
    return {
      rowInst: null,
      editor: new Editor({
        content: null,
        editable: false
      }),
      value: this.parseData(this.cellVal),
    }
  },
  computed: {
    firstValueElement() {
      return this.value ? this.value : ''
    },
  },
  watch: {
    cellVal() {
      this.value = this.parseData(this.cellVal)
    },
  },
  mounted() {
    let content = this.firstValueElement
    const editorValue = content !== undefined ? content : ""

    this.editor = new Editor({
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new Table({ resizable: true }),
        new TableHeader(),
        new TableCell(),
        new TableRow(),
      ],
      content: editorValue,
      editable: false
    })
  },
  methods: {
    parseData(data) {
      return data
    },
  },
  beforeDestroy() {
    this.value = null
  },
}
</script>

<style>
.value-container * {
  font-size: 0.875rem !important;
  padding: 0 !important;
  margin: 0 !important;
}
 .data-grid__cell {
  position: relative;
}
 .data-grid__cell._text {
  padding: 5px;
}
 .data-grid__cell .textCellDisplayColumn {
  color: #525f7f !important;
  font-weight: bold;
}
.ProseMirror:focus {
  outline: none;
}
.tableWrapper {
  margin: 1em 0;
  overflow-x: auto;
}
.tableWrapper table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 0;
  overflow: hidden;
}
.tableWrapper table td, .editor__content table th {
  min-width: 1em;
  border: 2px solid #ddd;
  padding: 3px 5px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}
.tableWrapper td>*, .editor__content table th>* {
  margin-bottom: 0;
}
</style>

